<div class="d-flex flex-row gap-2">
	<div>
		<select aria-label="Record Type" class="form-select" [(ngModel)]="selectedQueryNodeStrategyIndex"
			(change)="loadCharMetaData()" data-cy="CharTypeDropdown">
			@for (grp of queryNodeStrategyGroups | keyvalue; track grp) {
				<optgroup [label]="selectionTypeName(grp.key)">
					@for (selection of grp.value; track selection) {
						<option [value]="selection.index">
							{{selection.name}}
						</option>
					}
				</optgroup>
			}
		</select>
	</div>
	<div class="char-data-field">
		<select aria-label="Data Fields" class="form-select" [(ngModel)]="selectedCharDataTagLabel"
			(change)="loadComparators()" [disabled]="isLoadingCharMeta" data-cy="CharDataDropdown">
			<optgroup label="System Fields">
				@for (field of systemFields; track field) {
					<option [value]="field.tagLabel" [attr.data-cy]="field.label">
						{{field.label}}
					</option>
				}
			</optgroup>
			<optgroup label="Characteristics">
				@for (charData of charDatas; track charData; let i = $index) {
					<option [value]="charData.tagLabel" [attr.data-cy]="charData.label">
						{{ charData.label }}
					</option>
				}
			</optgroup>
		</select>
	</div>
	<div>
		<select aria-label="Comparator" class="form-select" [(ngModel)]="selectedComparatorIndex"
			[disabled]="isLoadingCharMeta" (change)="softResetValues()" data-cy="ComparatorDropdown">
			@for (comparator of comparators; track comparator; let i = $index) {
				<option [value]="i" [attr.data-cy]="comparator.value">
					{{ comparator.label }}
				</option>
			}
		</select>
	</div>
	@if (selectedCharData && hasParameters) {
		<div>
			<rl-query-node-value-entry [comparator]="selectedComparator" [characteristic]="selectedCharData"
				[values]="values" (valuesEntered)="updateValues($event)"></rl-query-node-value-entry>
		</div>
	}
</div>